module.exports = __webpack_public_path__ + "static/media/reblozyl-beta-thalassemia-logo.3b0a29eb.png";